import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import TurnedInIcon from '@mui/icons-material/TurnedIn';
import TurnedInNotIcon from '@mui/icons-material/TurnedInNot';
import Chip from "@mui/material/Chip";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { loadFileInfo } from "../../../actions/form";
import getBackendURL from "../../../api/api";
import { download } from "../../../request";
import { ESRState, Message } from "../../../types/data";
import { addUserToMessageViewedList, deleteUserFromMessageViewedList } from "../../../actions/util";

export const Comment = (props: Message) => {
	const { esrId = "", activeId = "" } = useParams();
	const dispatch = useDispatch();
	const filenames = useSelector((state: ESRState) => state.filenames);
	const current_user = useSelector((state: ESRState) => state.current_user);
	const [marked, setMessageMarked] = useState(true);
	const thread_id = props.thread_id;
	useEffect(() => {
		for (const fileId of props.file_ids) {
			dispatch(loadFileInfo(activeId, fileId));
		}
	}, [props.file_ids]);

	const toggleViewersList = ()=>{
		if(marked){
			dispatch(deleteUserFromMessageViewedList(props.id, esrId));
			setMessageMarked(false);
		}else{
			dispatch(addUserToMessageViewedList(props.id, esrId));
			setMessageMarked(true);
		}
	}
	return (
		<Stack direction="row" sx={{ gap: "12px", p: "16px 24px" }}>
			<Box
				sx={{
					width: 32,
					height: 32,
					borderRadius: 16,
					background: "green",
					color: "white",
					lineHeight: "32px",
					textAlign: "center",
					flex: "none",
				}}
			>
				{props.sender_id[0].toUpperCase()}
			</Box>
			<Box sx={{ flex: 1 }}>
				<Box sx={{ flex: "auto" }}>
					<Stack direction="row" sx={{ alignItems: "center" }}>
						<Typography fontSize={14} fontWeight={500}>
							{props.sender_id}
						</Typography>
						<Box sx={{ flex: 1 }} />
						{
							current_user?.email !== props.sender_id &&
							<Tooltip title={marked ? "View for later" : "Mark as viewed"}>
								<IconButton onClick={toggleViewersList}>
									{marked ? <TurnedInNotIcon color="primary"/> : <TurnedInIcon color="primary"/>}
								</IconButton>
							</Tooltip>
						}
						<Typography fontSize={12} color="#0000004D">
							{dayjs(props.timestamp).format("MM/DD/YYYY")}
						</Typography>
					</Stack>
				</Box>
				<Stack direction="row" sx={{ my: "8px", flexWrap: "wrap", gap: "4px" }}>
					{props.file_ids.map((fileId) => (
						<Chip
							key={fileId}
							label={filenames?.[fileId]}
							onClick={() =>
								download(
									getBackendURL(
										`/esr/attachment/?esr_id=${esrId}&file_id=${fileId}&thread_id=${thread_id}`,
									),
								)
							}
						/>
					))}
				</Stack>
				<Typography fontSize={14} fontWeight={400}>
					{props.contents}
				</Typography>
				<Typography fontSize={12} color="#0000004D">
					{new Date(props.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
				</Typography>

			</Box>
		</Stack>
	);
};
